import { useState, useEffect } from 'react'
import { Box, Button, useTheme, useMediaQuery } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import DividerComponent from '../../DividerComponent'

import IngenieriaForestalImg from '../../../../../assets/images/unl/format/colab-1.png'
import UNLImg from '../../../../../assets/images/unl/format/colab-5.png'
import CarreraComputacionImg from '../../../../../assets/images/unl/format/colab-6.png'
import CarreraAgropecuariaImg from '../../../../../assets/images/unl/format/colab-2.png'
import MunicipioLojaImg from '../../../../../assets/images/unl/format/colab-3.png'
import DireccionInvesImg from '../../../../../assets/images/unl/format/colab-4.png'

import 'swiper/css'

const clientImages = [
  { src: UNLImg, alt: 'Universidad Nacional de Loja' },
  { src: IngenieriaForestalImg, alt: 'Ingeniería Forestal' },
  { src: CarreraComputacionImg, alt: 'Carrera de Computación' },
  { src: CarreraAgropecuariaImg, alt: 'Carrera de Agropecuaria' },
  { src: MunicipioLojaImg, alt: 'Municipio de Loja' },
  { src: DireccionInvesImg, alt: 'Direción de Investigación' },
]

const ClientComponent = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [activeStep, setActiveStep] = useState(0)
  const maxSteps = clientImages.length

  // Autoplay para MobileStepper
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep(prev => (prev === maxSteps - 1 ? 0 : prev + 1))
    }, 3000) // cada 3 segundos

    return () => clearInterval(interval)
  }, [maxSteps])

  // Componente para pantallas pequeñas
  const renderMobileStepper = () => (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 70,
          mb: 1,
          px: 4,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 100,
          cursor: 'default',
          overflow: 'hidden',
        }}>
        {/* Botón izquierdo */}
        <Button
          onClick={() => setActiveStep(prev => prev - 1)}
          disabled={activeStep === 0}
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            minWidth: '50px',
            px: 1,
            zIndex: 1,
          }}>
          <KeyboardArrowLeft sx={{ height: '100%' }} />
        </Button>

        {/* Imagen */}
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'filter 0.4s ease, transform 0.3s ease',
            cursor: 'pointer',
            '&:hover img': {
              filter: 'grayscale(0%)',
            },
          }}>
          <Box
            sx={{
              '&:hover img': {
                filter: 'grayscale(0%)',
              },
            }}>
            <img
              src={clientImages[activeStep].src}
              alt={clientImages[activeStep].alt}
              style={{
                height: '100%',
                width: 'auto',
                maxWidth: '185px',
                filter: 'grayscale(100%)',
                transition: 'filter 0.4s ease',
              }}
            />
          </Box>
        </Box>

        {/* Botón derecho */}
        <Button
          onClick={() => setActiveStep(prev => prev + 1)}
          disabled={activeStep === maxSteps - 1}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            height: '100%',
            minWidth: '50px',
            px: 1,
            zIndex: 1,
          }}>
          <KeyboardArrowRight sx={{ height: '100%' }} />
        </Button>
      </Box>

      {/* Dots personalizados */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
          px: 2,
          mb: 1,
          pt: 2,
        }}>
        {Array.from({ length: maxSteps }).map((_, index) => (
          <Box
            key={index}
            // onClick={() => setActiveStep(index)}
            sx={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              cursor: 'pointer',
              backgroundColor: activeStep === index ? 'primary.main' : 'grey.400',
              transition: 'background-color 0.3s',
            }}
          />
        ))}
      </Box>
    </Box>
  )

  const renderSwiper = () => (
    <Box>
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        loop={clientImages.length > 3}
        centeredSlides={clientImages.length === 3}
        observer={true}
        observeParents={true}
        slidesPerView={clientImages.length === 3}
        spaceBetween={clientImages.length === 3 ? 0 : 250}
        breakpoints={{
          320: {
            slidesPerView: clientImages.length === 3 ? 1 : 2,
            spaceBetween: clientImages.length === 3 ? 0 : 10,
          },
          800: {
            slidesPerView: clientImages.length === 3 ? 1 : 3,
            spaceBetween: clientImages.length === 3 ? 0 : 20,
          },
          992: {
            slidesPerView: clientImages.length === 3 ? 1 : 4,
            spaceBetween: clientImages.length === 3 ? 0 : 60,
          },
        }}>
        {clientImages.map((item, idx) => (
          <SwiperSlide key={idx}>
            <Box
              onClick={() => setSelectedIndex(prev => (prev === idx ? null : idx))}
              sx={{
                cursor: 'pointer',
                height: 70,
                mx: 1,
                my: 1,
                px: 2,
                py: 1,
                minWidth: 100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'box-shadow 0.3s ease',
              }}>
              <img
                src={item.src}
                alt={item.alt}
                style={{
                  height: '100%',
                  width: 'auto',
                  maxWidth: '250px',
                  filter: selectedIndex === idx ? 'grayscale(0%)' : 'grayscale(100%)',
                  transition: 'filter 0.4s ease, transform 0.3s ease',
                }}
                onMouseEnter={e => {
                  if (selectedIndex !== idx)
                    e.currentTarget.style.filter = 'grayscale(0%)'
                }}
                onMouseLeave={e => {
                  if (selectedIndex !== idx)
                    e.currentTarget.style.filter = 'grayscale(100%)'
                }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  )

  return (
    <Box px={2} pb={4} pt={4} sx={{ bgcolor: '#fafafa70' }}>
      <DividerComponent
        label="Cooperación"
        sx={{ ml: { xs: 3, sm: 6, md: 6, lg: 6, xl: 7 }, mb: 5 }}
      />
      <Box>{isMobile ? renderMobileStepper() : renderSwiper()}</Box>
    </Box>
  )
}

export default ClientComponent
